// components/CountBadge.jsx

import React from 'react';

const CountBadge = ({ count, type = 'default', showZero = false, className = '' }) => {
    if (!showZero && count === 0) return null;

    const getColor = () => {
        switch (type) {
            case 'urgent':
                return 'bg-red-500 text-white';
            case 'delayed':
                return 'bg-orange-500 text-white';
            case 'success':
                return 'bg-green-500 text-white';
            case 'warning':
                return 'bg-yellow-500 text-white';
            case 'info':
                return 'bg-blue-500 text-white';
            default:
                return 'bg-gray-500 text-white';
        }
    };

    return (
        <span className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-bold rounded-full ${getColor()} ${className}`}>
            {count > 99 ? '99+' : count}
        </span>
    );
};

export default CountBadge;